import { render, staticRenderFns } from "./PaymentVerify.vue?vue&type=template&id=67059062&scoped=true"
import script from "./PaymentVerify.vue?vue&type=script&lang=js"
export * from "./PaymentVerify.vue?vue&type=script&lang=js"
import style0 from "./PaymentVerify.vue?vue&type=style&index=0&id=67059062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67059062",
  null
  
)

export default component.exports